export default __webpack_public_path__ + "static/media/channelFireballLogo.265ebada.png";